export const parseXml = (xml: string, docType: DOMParserSupportedType = 'text/xml'): Document => {
    const parser = new DOMParser();
    return parser.parseFromString(xml, docType);
};

export const getElementsByTagName = (xml: string, tagName: string, docType?: DOMParserSupportedType): HTMLCollectionOf<Element> => {
    const xmlDoc = parseXml(xml, docType);
    return xmlDoc.getElementsByTagName(tagName);
};

export const findFirstNodeByTagName = (xml: string, tagName: string, docType?: DOMParserSupportedType): Element => {
    return getElementsByTagName(xml, tagName, docType)?.[0];
};

export const getFirstNodeInnerHtmlByTagName = (xml: string, tagName: string, docType?: DOMParserSupportedType) => {
    return findFirstNodeByTagName(xml, tagName, docType)?.innerHTML;
};
